var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoubleSideArrow = function SvgDoubleSideArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "doubleSideArrow_svg__nav-symbol",
    viewBox: "0 0 14.1 12.6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14 .9-.7-.8L7 6.6l6.3 6.2.7-.7-5.6-5.5L14 .9zm-7 0L6.3.1 0 6.6l6.3 6.2.7-.7-5.6-5.5L7 .9z"
  })));
};
export default SvgDoubleSideArrow;